import React, { useState, useImperativeHandle, forwardRef } from "react";
import ReactDOM from "react-dom/client";
import classNames from "classnames";
import MessageItem from "./MessageItem";
import { MessageProps } from "./PropsType";

let seed = 0;
const now = Date.now();

const getUuid = () => {
  return `Message-${now}_${seed++}`;
};

export default function Message(props: MessageProps, ref) {
  const { className } = props;

  const [messages, setMessages] = useState<any>([]);
  const [hideBackdrop, setHideBackdrop] = useState(!!props.hideBackdrop);
  const styleClass = classNames(
    "Message",
    {
      "Message-none": messages.length <= 0,
    },
    className
  );

  const getMessageChildren = () => {
    const children: any[] = [];
    messages.map((message: any) => {
      const close = () => {
        destroy(message.key);
        if (message.onClose) {
          message.onClose();
        }
      };

      children.push(
        <MessageItem key={message.key} {...message} onClose={close} />
      );
    });
    return children;
  };

  const messagesChildren = getMessageChildren();

  const open = (messageItem: any = {}) => {
    if (messageItem) {
      const key = messageItem.key ? messageItem.key : getUuid();
      const hideBackdrop = Boolean(messageItem.hideBackdrop);
      messageItem.key = key;
      messageItem.hideBackdrop = hideBackdrop;
      const messagess = [...messages];
      let isExit = false;
      for (const message of messagess) {
        if (message.key === key) {
          isExit = true;
          break;
        }
      }
      if (!isExit) {
        messagess.push(messageItem);
        setMessages(messagess);
        setHideBackdrop(hideBackdrop);
      }
    }
    return messageItem;
  };

  const destroy = (key: any) => {
    setMessages((previousState: any) => {
      const messages = previousState.filter(
        (message: any) => message.key !== key
      );
      return [...messages];
    });
  };

  const handleClose = () => {
    const messagess = [...messages];
    if (messagess.length > 0) {
      destroy(messagess[messagess.length - 1].key);
    }
    if (props.onClose) {
      (props.onClose as () => void)();
    }
  };

  useImperativeHandle(ref, () => {
    return {
      instance: {
        open,
        destroy,
      },
    };
  });

  return (
    <div className={styleClass}>
      {messages.length > 0 && hideBackdrop ? (
        <div onClick={handleClose} className="Message-mask" />
      ) : null}
      {messagesChildren}
    </div>
  );
}

const MessageRef = forwardRef(Message);

let message: any = null;

let taskQueue: any = [];
let messageContainer: HTMLDivElement;
let root: any = null;

Message.create = (props: any = {}) => {
  if (!message) {
    message = {};
    messageContainer = document.createElement("div");
    messageContainer.id = 'bm_messageBox';
    document.body.appendChild(messageContainer);

    root = ReactDOM.createRoot(messageContainer);
    root.render(
      <MessageRef
        ref={(node: any) => {
          if (!message?.instance) {
            message.instance = node.instance;
          }
          Message.create();
        }}
        {...props}
      />
    );
  } else {

  }
  if (message?.instance) {
    taskQueue.forEach((task: any) => {
      const { type, params } = task;
      switch (type) {
        case "open":
          message.instance?.open?.(params);
          break;
        case "destroy":
          message.instance?.destroy?.(params.key);
          break;
        default:
      }
    });
    taskQueue = [];
  }
  return {
    open(params: any) {
      // console.log(message);
      // console.log(ref);
      // return ref?.add?.(params);
      if (message?.instance) {
        return message.instance?.open?.(params);
      } else {
        taskQueue.push({
          type: "open",
          params,
        });
      }
    },
    destroy(key: any) {
      if (message?.instance) {
        message.instance?.destroy?.(key);
      } else {
        taskQueue.push({
          type: "destroy",
          key,
        });
      }
      // ref?.destroy?.(key);
    },
    clearAll() {
      root.unmount();
      message = null;
      document.body.removeChild(messageContainer);
    },
    component: message,
  };
};
